// Youssef Selkani
// 2019

import React, { Component } from "react";
import "../App.css";
import { Container, } from 'semantic-ui-react';


class Thanks extends Component {
  render() {
    return (
      <Container style={{
        display: 'flex', minHeight: window.innerHeight / 1.25,
        alignItems: 'center', justifyContent: 'center',
      }}>
        <center>
          <h1>Thank you for your purchase!</h1>
          <p>You'll hear from us pretty soon.</p>
        </center>
        
      </Container>
    );
  }
}

export default Thanks;